// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"ClosedGroupListCard_filterContainer__gL4jW","paginationWrapper":"ClosedGroupListCard_paginationWrapper__gnl6L"};